import * as React from 'react'

import {cn} from '@containers/html-utils'

interface Props {
  value: () => string
  getValue?: (val: string) => void
  fixedLength?: number
}

interface State {
  value: string
}
/**
 * Allows to show value that is changed with time.
 * Usage example:
 * <div className="info-now">
 *   <TimeValue value={() => new Date().toString()} />
 * </div>
 */
export class TimeValue extends React.Component<Props> {
  public override state: State = {value: ''}
  private timerHandler: TimeoutHandler | undefined

  constructor(props: Props) {
    super(props)
  }

  public override componentDidMount(): void {
    this.setState({value: this.props.value()})
    this.props?.getValue?.(this.props.value())
    this.timerHandler = setInterval(() => {
      const value = this.props.value()
      if (value !== this.state.value) {
        this.setState({value})
        this.props?.getValue?.(value)
      }
    }, 1000)
  }

  public override componentWillUnmount(): void {
    if (this.timerHandler) {
      clearInterval(this.timerHandler)
    }
  }

  public override render(): React.ReactNode {
    const value = this.state.value
    const {fixedLength} = this.props

    let cls = ''
    if (fixedLength && value.includes(':') && value.length === fixedLength) {
      if (fixedLength === 7) {
        cls = 'min-w-46 max-w-46'
      } else if (this.props.fixedLength === 8) {
        cls = 'min-w-54 max-w-54'
      }
    }

    return <div className={cn('time-value', cls)}>{this.state.value}</div>
  }
}
